import { fromJS } from 'immutable';
import { actionType } from 'Workspace/Publications/utils/constants';
import * as constants from './constants';

const PUBLICATIONS_LIST_PATH = 'publications';
const PUBLICATIONS_HISTORY_LIST_PATH = 'history';

const initialState = {
  publications: null,
  publicationsSort: {
    key: null,
    type: null,
    order: null,
  },
};

// NOTE : publications.market can be null, but market can be undefined - hence the ==
const findInPublicationsList = (state, activityId, outputType, market) => (
  [PUBLICATIONS_LIST_PATH, state.get(PUBLICATIONS_LIST_PATH).findIndex((publications) => publications.activityId === activityId
    && (publications.outputType === outputType) && (publications.market == market))]
);

const findInPublicationHistoryList = (state, publication) => {
  const publicationItem = state.getIn([...findInPublicationsList(state, publication.activityId, publication.version, publication.market)]);
  return [
    ...findInPublicationsList(state, publication.activityId, publication.version, publication.market),
    PUBLICATIONS_HISTORY_LIST_PATH,
    getPublicationHistoryItem(publicationItem, publication.publicationId)];
};

const getPublicationHistoryItem = (publicationItem, publicationId) => (
  publicationItem.history.findIndex((publicationHistoryItem) => publicationHistoryItem.publicationId === publicationId));

const updatePublicationsList = (state, publication, updateType) => {
  if (updateType === actionType.PUBLISH) {
    return state.updateIn([...findInPublicationsList(state, publication.activityId, publication.version, publication.market), PUBLICATIONS_HISTORY_LIST_PATH],
      (publicationList) => [publication].concat(publicationList));
  } else if (updateType === actionType.DELETE) {
    const path = findInPublicationHistoryList(state, publication);
    return state.deleteIn([...path]);
  }
};

const setPublicationHistoryForActivity = (state, historyList, activityId, outputType, market) => {
  const path = findInPublicationsList(state, activityId, outputType, market);
  return state.setIn([...path, PUBLICATIONS_HISTORY_LIST_PATH], historyList);
};

const updatePublicationStatus = (state, publication) => {
  const path = findInPublicationHistoryList(state, publication);
  return state
    .setIn([...path, 'publicationJobStatus'], publication.publicationJobStatus)
    .setIn([...path, 'statusMessage'], publication.statusMessage)
    .setIn([...path, 'etextVersion'], publication.etextVersion)
    .setIn([...path, 'bookId'], publication.bookId);
};

const updatePublicationDetail = (state, publication) => {
  const path = findInPublicationsList(state, publication.activityId, publication.version);
  return state
    .setIn([...path, 'updatedAt'], publication.updatedAt)
    .setIn([...path, 'publishedBy'], publication.publishedBy)
    .setIn([...path, 'author'], publication.author)
    .setIn([...path, 'publisherFamilyName'], publication.publisherFamilyName)
    .setIn([...path, 'publisherGivenName'], publication.publisherGivenName);
};

function workspacePublicationsReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.SET_PUBLICATION_LIST:
      return state.set('publications', action.publications);

    case constants.SET_PUBLICATION_HISTORY:
      return setPublicationHistoryForActivity(state, action.historyList, action.activityId, action.outputType, action.market);

    case constants.SET_PUBLICATIONS_SORT:
      return state.set('publicationsSort', action.sort);

    case constants.SET_PUBLICATIONS_SEARCH:
      return state.set('publicationsSearch', action.search);

    case constants.UPDATE_PUBLICATION_LIST:
      return updatePublicationsList(state, action.publication, action.updateType);

    case constants.UPDATE_PUBLICATION_DETAIL:
      return updatePublicationDetail(state, action.publication);

    case constants.UPDATE_PUBLICATION_STATUS:
      return updatePublicationStatus(state, action.publication);

    default:
      return state;
  }
}

export default workspacePublicationsReducer;
